import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Panel from '../../components/common/Panel';
import BackTop from '../../components/common/BackTop';
import PageLayout from '../../components/common/PageLayout';
import { ActivationHeader } from '../../components/blocks/ActivationHeader';
import ActivationPaymentContainer from '../blocks/ActivationPaymentContainer';
import ActivationServicesContainer from '../blocks/ActivationServicesContainer';
import { getActivationSupplier } from '../../store/actions/activation';
import { AnalyticsSpinner } from '../../components/common/Spinner/AnalyticsSpinner';
import { useParams } from 'react-router-dom';
import { useRetailerType } from '../../hooks/useRetailerType';
import { OperatorSellerPage } from './operators/OperatorSellerPage';
import { OperatorsActions } from '../../store/reducers/operators';

export default function ActivationPageContainer() {
  const { isOperator } = useRetailerType();
  const dispatch = useDispatch();
  const { supplierId } = useParams();
  const { supplier, isLoading } = useSelector((state) => state.activation);
  const { loaded } = useSelector((state) => state.operators);

  useEffect(() => {
    if (supplierId) {
      dispatch(getActivationSupplier(Number(supplierId)));
    }
    return () => {
      dispatch({ type: OperatorsActions.loaded, payload: false });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supplierId]);

  if (isLoading || !supplier || !loaded) {
    return <AnalyticsSpinner fullScreen />;
  }

  const hasPublishableKey = supplier?.stripe_publishable_key;

  const panel = (
    <Panel>
      <BackTop />
    </Panel>
  );

  return (
    <PageLayout top={panel}>
      <ActivationHeader />
      {isOperator ? (
        <OperatorSellerPage />
      ) : (
        <>
          <ActivationServicesContainer />
          {hasPublishableKey && <ActivationPaymentContainer supplierData={supplier} />}
        </>
      )}
    </PageLayout>
  );
}
